import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const settingsStore = useSettingsStore();
    const {
      theme,
      logo,
      title
    } = storeToRefs(settingsStore);
    const __returned__ = {
      settingsStore,
      theme,
      logo,
      title
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});